import { render, staticRenderFns } from "./ModalTableComponent.vue?vue&type=template&id=3a8256d3&scoped=true"
import script from "./ModalTableComponent.vue?vue&type=script&lang=js"
export * from "./ModalTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalTableComponent.vue?vue&type=style&index=0&id=3a8256d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8256d3",
  null
  
)

export default component.exports